import { render, staticRenderFns } from "./HospitalsSearchTable.vue?vue&type=template&id=0ecf0b8e&scoped=true&"
import script from "./HospitalsSearchTable.vue?vue&type=script&lang=js&"
export * from "./HospitalsSearchTable.vue?vue&type=script&lang=js&"
import style0 from "./HospitalsSearchTable.vue?vue&type=style&index=0&id=0ecf0b8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf0b8e",
  null
  
)

export default component.exports